import { createApp, h } from 'vue';
import { createPinia } from 'pinia';
import { createI18n } from 'vue-i18n';
import App from './App.vue';
import router from './router';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './assets/css/main.css';
import { initServiceWorker } from './services/pwa';
import { rbacPlugin } from './rbac/plugin';
import RbacNoticeHost from './rbac/RbacNoticeHost';
import { startPermissionSync } from './rbac/refresh';
import { startSessionScope } from './stores/sessionScope';

// Create i18n instance
const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('locale') || 'en',
  fallbackLocale: 'en',
  messages: {
    en,
    fr,
  },
});

// Create Vue app. The RBAC notice host sits next to <App/> so "your access
// changed" / "your session was ended" notices show on every route (dashboard
// layout, full-page routes, the sign-in page).
const app = createApp({ name: 'TasklicRoot', render: () => [h(App), h(RbacNoticeHost)] });

// Use plugins
app.use(createPinia());
app.use(router);
app.use(i18n);
app.use(rbacPlugin); // v-can + <Can>

// Per-user stores and RBAC notices end with the session (sign-out, or
// another user signing in in the same tab).
startSessionScope();

// Keep the signed-in person's permissions in step with the server
// (socket permissions:changed / session:revoked, X-Permissions-Version, focus).
// Also keeps the socket connected for any signed-in staff session.
startPermissionSync(router);

// Mount app
app.mount('#app');

// Register the service worker + start polling for new deploys. After mount
// so it never delays first paint.
initServiceWorker();
